<template>
  <div class="monitor-container">
    <!-- 标签页区域 -->
    <el-tabs 
      v-model="activeTab" 
      type="card"                
      tab-position="left"
      @tab-change="handleTabChange"
    > 
      

      <!-- 主机调试 -->
      <el-tab-pane name="6" :label="renderTabLabel(slaveTabs[0])">
        <SystemHostDebugParmaterSet
          v-if="activeTab === '6'"
          :projectId="currentProjectId"
          :collectionId="currentCollectionId"
          :domainMenuId="currentDomainMenuId"   
          :domainId="currentDomainId"                       
        />
      </el-tab-pane>
      
      <!-- 手动调试 -->
      <el-tab-pane name="8" :label="renderTabLabel(slaveTabs[1])">
        <SystemHandDebugParmaterSet 
          v-if="activeTab === '8'"
          :projectId="currentProjectId"
          :collectionId="currentCollectionId"
          :domainMenuId="currentDomainMenuId"   
          :domainId="currentDomainId"    
        />
      </el-tab-pane>
      

    </el-tabs>
  </div>
</template>

<script setup>
import { ref, onMounted, defineExpose,defineProps,watch } from 'vue'
import SystemHostDebugParmaterSet from "@/components/clientViews/ClientDeviceMonitorSystemDebugParmaterSet.vue";
import SystemHandDebugParmaterSet from "@/components/clientViews/ClientDeviceMonitorSystemHandDebugParmaterSet.vue";

import { useI18n } from "vue-i18n";

const { t } = useI18n();
// 响应式数据
const activeTab = ref('6')
const slaveTabs = ref([  
  { name: '6', label: t('message.ClientDeviceMonitorSystemDebug.hostDebug') },
  { name: '8', label: t('message.ClientDeviceMonitorSystemDebug.handDebug') }
])
        
const props = defineProps({
  projectId: {
    type: [String, Number],
    required: true
  },
  collectionId: {
    type: [String, Number],
    required: true
  },
  domainMenuId: {
    type: [String, Number],
    required: true
  },
  projectName: {
    type: String,
    default: ''
  }
})

// 使用 props 数据
const currentProjectId = ref(props.projectId);
const currentCollectionId = ref(props.collectionId);
const currentDomainMenuId = ref(props.domainMenuId); 
const currentDomainId = ref(activeTab.value);
 
const handleTabChange = (name) => {
  console.log('切换到标签:', name)
  // 这里可以添加标签切换时的逻辑
}

const renderTabLabel = (tab) => {
  return tab.label
}

 // 监听 activeTab 变化，更新 currentDomainId
watch(activeTab, (newTab) => {
  currentDomainId.value = newTab;
  console.log('当前domainId更新为:', currentDomainId.value)
})

// 暴露方法给父组件
defineExpose({
  handleTabChange
})

onMounted(() => {
  // 初始化逻辑
})
</script>

<style scoped>
.monitor-container {
  padding: 0px;
  background: #f5f7fa;  
  height: 100%;  
  overflow: hidden;
}

.class-tabs {
  background: white;
  border-radius: 1px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);  
}

:deep(.el-tabs--left) {
  min-height: 10px;
}

:deep(.el-tabs--left .el-tabs__header.is-left) {
  width: 100px;
  background: #f8f9fa;
  border-right: 1px solid #e4e7ed;
}

:deep(.el-tabs--left .el-tabs__active-bar.is-left) {
  right: 0;
  left: auto;
  width: 3px;
}

:deep(.el-tabs--left .el-tabs__item.is-left) {
  text-align: left;
  padding: 12px 20px;
  border-bottom: 1px solid #e4e7ed;
}

:deep(.el-tabs--left .el-tabs__item.is-left.is-active) {
  background: #ecf5ff;
  color: #409eff;
  font-weight: 500;
}

:deep(.el-tabs--left .el-tabs__item.is-left:hover) {
  background: #ecf5ff;
  color: #409eff;
}

:deep(.el-tabs__nav-wrap::after) {
  background-color: transparent;
}

:deep(.el-tabs--card > .el-tabs__header .el-tabs__item) {
  border-bottom: none;
}

:deep(.el-tabs--card > .el-tabs__header .el-tabs__nav) {
  border: none;
}

:deep(.el-tabs--card > .el-tabs__header) {
  border-bottom: none;
}
 
 
.setting-content {
  flex: 1;
  display: flex;
  flex-direction: column;    
  height: 100%;
  overflow:hidden; 
}
 
/* 响应式设计 */
@media (max-width: 768px) {
  :deep(.el-tabs--left .el-tabs__header.is-left) {
    width: 120px;
  }
 
  .monitor-container {
    padding: 10px;
  }
  
  :deep(.el-tabs--left .el-tabs__item.is-left) {
    padding: 10px 15px;
    font-size: 14px;
  }
}
</style> 